<template>
  <div class="row">
    <div class="col-12">
      <div id="card-add-person-members" class="card">
        <div class="card-body">
          <h3 class="card-title">Person Members</h3>
          <pipeline-status-alert
            :pipeline-response-name="responseName"
            for-type="person" for-role="member">
          </pipeline-status-alert>
          <current-members-display :current-members="personMembers"
                                   member-type="person"
                                   main-attribute="roleId"
                                   secondary-attribute="displayName">
          </current-members-display>
          <form @submit.prevent="requestAddPersonMembers">
            <div class="form-group" :class="{ 'invalid': $v.addPersonMembersForm.members.$error }">
              <label for="addMembersField">Add Members by PID or Guest ID</label>
              <textarea id="addMembersField"
                        class="form-control"
                        rows="3"
                        aria-describedby="addMembersDesc"
                        v-model="$v.addPersonMembersForm.members.$model">
                </textarea>
              <small id="add-members-help"
                     class="form-text text-muted text-break-word">
                The following delimiters will work: spaces, commas, semicolons, new lines
              </small>
            </div>
            <p id="err-add-mem-minlength"
               v-if="!$v.addPersonMembersForm.members.minLength"
               class="error-message">
              PID/Guest ID must be at least {{$v.addPersonMembersForm.members.$params.minLength.min}} characters.
            </p>
            <button id="btn-add-persons"
                    type="submit"
                    class="btn btn-primary"
                    :disabled="$v.addPersonMembersForm.members.$invalid || addPersonMembersForm.submitting === true">
              {{addPersonMembersForm.submitting === true ? 'Submitting...' : 'Add Person Members'}}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';
import { groupsMixin, util } from '../../util/groups-mixin';
import PipelineStatusAlert from '../PipelineStatusAlert';
import CurrentMembers from './CurrentMembers';

export default {
  name: 'AddPersonMembers',
  mixins: [groupsMixin, util],
  props: {
    responseName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      addPersonMembersForm: {
        members: '',
        submitting: false,
      },
    };
  },
  components: {
    'pipeline-status-alert': PipelineStatusAlert,
    'current-members-display': CurrentMembers,
  },
  computed: {
    personMembers() {
      return this.$store.getters.groupMembers(this.managedGroup, 'person');
    },
    newMembers() {
      return this.arrayFromDelimitedString(this.addPersonMembersForm.members);
    },
  },
  methods: {
    resetAddPersonMembersForm() {
      this.addPersonMembersForm.members = '';
      this.addPersonMembersForm.submitting = false;
      this.$nextTick(() => { this.$v.$reset(); });
    },
    requestAddPersonMembers() {
      const vm = this;
      this.$store.dispatch('clearPipelinedStateResponse', this.responseName);
      /* validate form */
      this.$v.$touch();
      /* if form isn't invalid */
      if (!this.$v.addPersonMembersForm.members.$invalid) {
        this.addPersonMembersForm.submitting = true;
        this.$store.dispatch('batchModifyGroupRoles',
          {
            uugid: vm.managedGroup.uugid,
            type: 'members',
            kind: 'person',
            roleIds: this.newMembers,
            modify: 'add',
            responseToSet: vm.responseName,
          })
          .then(() => {
            vm.scrollToElement('card-add-person-members');
          })
          .finally(() => {
            this.resetAddPersonMembersForm();
          });
      }
    },
  },
  validations: {
    addPersonMembersForm: {
      members: {
        required,
        minLength: minLength(3),
      },
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/add-members/AddPersonMembers.vue